import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { WIDTHS } from './Constants';

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginHorizontal: `-${WIDTHS.CELL_PADDING / 2}px`
  },
  slide: {
    paddingHorizontal: `${WIDTHS.CELL_PADDING / 2}px`
  }
};

const StaticWrapper = ({ children, slideWidth }) => {
  const { Block } = UX2.Element;
  return (
    <Block style={ styles.wrapper }>
      { children.map(child => (
        <Block
          key={ child.key }
          style={{
            width: `${slideWidth}px`,
            ...styles.slide
          }}
        >
          { child }
        </Block>
      )) }
    </Block>
  );
};

StaticWrapper.propTypes = {
  children: PropTypes.any,
  slideWidth: PropTypes.number
};

export default StaticWrapper;
